<img src="assets/images/Alphabees_Logo_2026_indigo_solid_optimized.svg" alt="Alphabees Logo" class="auth-logo" />

<div class="auth-toggle">
  <a class="toggle-btn" routerLink="../login">Login</a>
  <a class="toggle-btn active" routerLink="../register">Register</a>
</div>

<!-- Registration refused because an unconfirmed account already exists for
     this address. Turning the person away with "Email already registered"
     leaves them exactly where they started, so offer the one thing that
     moves them forward — same treatment as the login page. -->
<nb-alert *ngIf="unconfirmedEmail" outline="warning" role="alert">
  <p class="alert-title">
    <b>{{ "pages.register.unconfirmed.title" | translate }}</b>
  </p>
  <p class="alert-message">
    {{ "pages.register.unconfirmed.description" | translate }}
  </p>

  <button
    *ngIf="!resendSuccess"
    nbButton
    status="warning"
    size="small"
    [nbSpinner]="resendLoading"
    nbSpinnerStatus="control"
    [disabled]="resendLoading"
    (click)="resendConfirmation()"
  >
    {{ "pages.register.unconfirmed.resendButton" | translate }}
  </button>

  <p class="alert-message" *ngIf="resendSuccess">
    {{ "pages.register.unconfirmed.resendSuccess" | translate }}
  </p>
  <p class="alert-message status-danger" *ngIf="resendError">
    {{ resendError | translate }}
  </p>
</nb-alert>

<nb-alert
  *ngIf="showMessages.error && errors?.length && !submitted"
  outline="danger"
  role="alert"
>
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert
  *ngIf="showMessages.success && messages?.length && !submitted"
  outline="success"
  role="alert"
>
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">
      {{ message }}
    </li>
  </ul>
</nb-alert>

<form (ngSubmit)="register()" #form="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <input
      nbInput
      [(ngModel)]="user.fullName"
      #fullName="ngModel"
      id="input-name"
      name="fullName"
      placeholder="{{ 'input.fullName.placeholder' | translate }}"
      autofocus
      fullWidth
      fieldSize="large"
      [status]="
        fullName.dirty ? (fullName.invalid ? 'danger' : 'success') : 'basic'
      "
      [required]="getConfigValue('forms.validation.fullName.required')"
      [minlength]="getConfigValue('forms.validation.fullName.minLength')"
      [maxlength]="getConfigValue('forms.validation.fullName.maxLength')"
      [attr.aria-invalid]="fullName.invalid && fullName.touched ? true : null"
    />
    <ng-container *ngIf="fullName.invalid && fullName.touched">
      <p class="caption status-danger" *ngIf="fullName.errors?.['required']">
        Full name is required!
      </p>
      <p
        class="caption status-danger"
        *ngIf="fullName.errors?.['minlength'] || fullName.errors?.['maxlength']"
      >
        {{
          "pages.register.errors.fullNameLength"
            | translate
              : {
                  minLength: getConfigValue(
                    "forms.validation.fullName.minLength"
                  ),
                  maxLength: getConfigValue(
                    "forms.validation.fullName.maxLength"
                  )
                }
        }}
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <input
      nbInput
      [(ngModel)]="user.email"
      #email="ngModel"
      id="input-email"
      name="email"
      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
      placeholder="{{ 'input.email.placeholder' | translate }}"
      fullWidth
      fieldSize="large"
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.email.required')"
      [attr.aria-invalid]="email.invalid && email.touched ? true : null"
    />
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="caption status-danger" *ngIf="email.errors?.['required']">
        {{ "pages.register.errors.emailRequired" | translate }}
      </p>
      <p class="caption status-danger" *ngIf="email.errors?.['pattern']">
        {{ "pages.register.errors.emailPattern" | translate }}
      </p>
    </ng-container>
  </div>

  <div class="form-control-group" *ngIf="user.email" [@fadeInRightOnEnter]>
    <input
      nbInput
      [(ngModel)]="user.emailRepeat"
      #emailRepeat="ngModel"
      id="input-email-repeat"
      name="emailRepeat"
      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
      placeholder="{{ 'input.emailRepeat.placeholder' | translate }}"
      fullWidth
      fieldSize="large"
      [status]="
        emailRepeat.dirty
          ? emailRepeat.invalid || email.value != emailRepeat.value
            ? 'danger'
            : 'success'
          : 'basic'
      "
      [required]="getConfigValue('forms.validation.email.required')"
      [attr.aria-invalid]="
        emailRepeat.invalid && emailRepeat.touched ? true : null
      "
    />
    <ng-container *ngIf="emailRepeat.invalid && emailRepeat.touched">
      <p class="caption status-danger" *ngIf="emailRepeat.errors?.['required']">
        {{ "pages.register.errors.emailRequired" | translate }}
      </p>
      <p class="caption status-danger" *ngIf="emailRepeat.errors?.['pattern']">
        {{ "pages.register.errors.emailPattern" | translate }}
      </p>
    </ng-container>

    <p
      class="caption status-danger"
      *ngIf="email.value != emailRepeat.value && !emailRepeat.errors"
    >
      {{ "pages.register.errors.emailNotMatch" | translate }}
    </p>
  </div>

  <div class="form-control-group">
    <input
      nbInput
      [(ngModel)]="user.password"
      #password="ngModel"
      type="password"
      id="input-password"
      name="password"
      placeholder="{{ 'input.password.placeholder' | translate }}"
      fullWidth
      fieldSize="large"
      [status]="
        password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'
      "
      [required]="getConfigValue('forms.validation.password.required')"
      [minlength]="getConfigValue('forms.validation.password.minLength')"
      [maxlength]="getConfigValue('forms.validation.password.maxLength')"
      [attr.aria-invalid]="password.invalid && password.touched ? true : null"
    />
    <ng-container *ngIf="password.invalid && password.touched">
      <p class="caption status-danger" *ngIf="password.errors?.['required']">
        {{ "pages.register.errors.passwordRequired" | translate }}
      </p>
      <p
        class="caption status-danger"
        *ngIf="password.errors?.['minlength'] || password.errors?.['maxlength']"
      >
        {{
          "pages.register.errors.passwordLength"
            | translate
              : {
                  minLength: getConfigValue(
                    "forms.validation.password.minLength"
                  ),
                  maxLength: getConfigValue(
                    "forms.validation.password.maxLength"
                  )
                }
        }}
      </p>
    </ng-container>
  </div>

  <div class="form-control-group" *ngIf="user.password" [@fadeInRightOnEnter]>
    <input
      nbInput
      [(ngModel)]="user.confirmPassword"
      #rePass="ngModel"
      type="password"
      id="input-re-password"
      name="rePass"
      placeholder="{{ 'input.repeatPassword.placeholder' | translate }}"
      fullWidth
      fieldSize="large"
      [status]="
        rePass.dirty
          ? rePass.invalid || password.value != rePass.value
            ? 'danger'
            : 'success'
          : 'basic'
      "
      [required]="getConfigValue('forms.validation.password.required')"
      [attr.aria-invalid]="rePass.invalid && rePass.touched ? true : null"
    />
    <ng-container *ngIf="rePass.invalid && rePass.touched">
      <p class="caption status-danger" *ngIf="rePass.errors?.['required']">
        {{ "pages.register.errors.passwordRequired" | translate }}
      </p>
    </ng-container>

    <p
      class="caption status-danger"
      *ngIf="password.value != rePass.value && !rePass.errors"
    >
      {{ "pages.register.errors.passwordNotMatch" | translate }}
    </p>
  </div>

  <div class="form-control-group accept-group">
    <nb-checkbox name="newsletter" [(ngModel)]="user.newsletter" class="newsletter-checkbox">
      {{ "pages.register.newsletterSignup" | translate }}
    </nb-checkbox>
  </div>

  <div
    class="form-control-group accept-group"
    *ngIf="getConfigValue('forms.register.terms')"
  >
    <nb-checkbox
      name="terms"
      [(ngModel)]="user.terms"
      [required]="getConfigValue('forms.register.terms')"
    >
      <a routerLink="/auth/terms-and-conditions" target="_blank">
        {{ "pages.register.agreeToTerms" | translate }}
      </a>
    </nb-checkbox>
  </div>

  <app-turnstile
    (tokenReceived)="onCaptureTokenReceived($event)"
    [onRenew]="renewToken$"
  ></app-turnstile>
  <button
    nbButton
    fullWidth
    status="primary"
    size="large"
    [disabled]="submitted || !form.valid || !captureToken"
    [class.btn-pulse]="submitted"
    [nbSpinner]="!captureToken"
  >
    {{ "buttons.register" | translate }}
  </button>
</form>

<section
  *ngIf="socialLinks && socialLinks.length > 0"
  class="links"
  aria-label="Social sign in"
>
  or enter with:
  <div class="socials">
    <ng-container *ngFor="let socialLink of socialLinks">
      <a
        *ngIf="socialLink.link"
        [routerLink]="socialLink.link"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
      <a
        *ngIf="socialLink.url"
        [attr.href]="socialLink.url"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
    </ng-container>
  </div>
</section>

